import { useState, useEffect } from 'react';
import moment from 'moment';

import { VideoBlockUrls, Refresh, VideoCap, TwoVideosPlace } from 'libs/ui';

export const RackVideos = (props) => {
  const { cams, id, cl, simple } = props;
  const [createtime, setCreatetime] = useState(1);

  const updateTime = () => {
    const createtime = moment().unix();
    setCreatetime(createtime);
  };

  useEffect(() => {
    updateTime();
  }, []);

  /**
   * refresh video
   */
  const refresh = () => {
    updateTime();
  };

  // if no cams
  if (cams === null || !cams.length) {
    return (
      <VideoCap
        className={cl}
        style={{
          height: '396px',
          width: '500px',
        }}
      />
    );
  }

  // prepare blocks
  const videos = [];
  if (cams !== null) {
    videos.push(<VideoBlockUrls key="vblock1" createtime={createtime} rackId={id} camHeight="310px" cams={[cams[0]]} />);
    if (cams.length > 1) {
      videos.push(
        <VideoBlockUrls
          key="vblock2"
          createtime={createtime}
          rackId={id}
          camHeight="310px"
          //cams={['main', 'face_lower']}
          cams={cams.slice(1)}
        />
      );
    }
  }

  return (
    <TwoVideosPlace>
      {!simple && <Refresh onClick={refresh} />}
      {videos}
    </TwoVideosPlace>
  );
};
